import React, {useEffect, useState} from "react";
import Slider from "react-slick";


/**
 * Threshold from which mouse movement with pressed mouse button
 * is considered a drag instead of a click.
 */
const MoveDragThreshold = 10;


function useDragDetection() {
  const [mouseDown, setMouseDown] = useState(false);
  const [dragging, setDragging] = useState(false);

  useEffect(() => {
    let mouseMove = 0;

    function handleMouseUp() {
      setMouseDown(false);
    }

    function handleMouseMove(e) {
      mouseMove += Math.abs(e.movementX) + Math.abs(e.movementY);
      setDragging(mouseMove > MoveDragThreshold);
    }

    if (mouseDown) {
      document.addEventListener("mouseup", handleMouseUp);
      document.addEventListener("mousemove", handleMouseMove);
    }

    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, [mouseDown]);

  function handleMouseDown() {
    setMouseDown(true);
    setDragging(false);
  }

  return {
    handleMouseDown,
    dragging,
  };
}

export function ClickableSlider(props) {
  const { children,  ...sliderProps } = props;

  const {
    handleMouseDown,
    dragging,
  } = useDragDetection();

  function handleChildClick(e){
    if (dragging) {
      e.preventDefault();
    }
  }

  const SliderNextArrow = ({ currentSlide, slideCount, ...props }) => (
      <button {...props}
              type="button"
              aria-hidden="true"
              aria-disabled={currentSlide === slideCount-1}
              className="z-1 border-0 position-absolute bg-white d-flex align-items-center justify-content-center clickable slick-arrow slick-arrow-right">
        <span className="mdi mdi-chevron-right"></span>
      </button>);
  const SliderPrevArrow = ({ currentSlide, slideCount, ...props }) => (
      <button {...props}
              type="button"
              aria-hidden="true"
              aria-disabled={currentSlide === 0}
              className="z-1 border-0 position-absolute bg-white d-flex align-items-center justify-content-center clickable slick-arrow slick-arrow-left">
        <span className="mdi mdi-chevron-left"></span>
      </button>);

  const sliderSettings = {
    dots: true,
    infinite: children?.length > 3,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    easing: 'ease-in-out',
    nextArrow: <SliderNextArrow />,
    prevArrow: <SliderPrevArrow />,
  };

  let mergedSettings = Object.assign({}, sliderSettings, sliderProps);

  return (
      <Slider {...mergedSettings}>
        {React.Children.map(children, (child) => (
            <div
                onMouseDownCapture={handleMouseDown}
                onClickCapture={handleChildClick}
            >
              {child}
            </div>
        ))}
      </Slider>
  );
}